export default __webpack_public_path__ + "static/media/SE.457653d3.ico";